<div class="container">
  <div class="error">
    <svg xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" version="1.1" id="svg2" width="150" height="80" viewBox="0 0 400 354.66666" sodipodi:docname="Final logo-01.eps">
      <defs id="defs6"/>
      <g id="g8" inkscape:groupmode="layer" inkscape:label="ink_ext_XXXXXX" transform="matrix(1.3333333,0,0,-1.3333333,0,354.66667)">
        <g id="g10" transform="scale(0.1)">
          <path d="M 933.77,179.359 H 813.59 V 909.328 H 933.77 V 179.359" style="fill:var(--custom-color-for-logo);fill-opacity:1;fill-rule:nonzero;stroke:none" id="path12"/>
          <path d="m 1317.27,839.23 h 120.18 V 179.359 h -120.18 z m -242.12,70.098 h 604.42 V 795.039 h -604.42 v 114.289" style="fill:var(--custom-color-for-logo);fill-opacity:1;fill-rule:nonzero;stroke:none" id="path14"/>
          <path d="m 1609.92,305.43 h 126.05 V 179.359 H 1609.92 V 305.43" style="fill:var(--custom-color-for-logo);fill-opacity:1;fill-rule:nonzero;stroke:none" id="path16"/>
          <path d="m 2014.71,179.359 h -120.18 v 729.969 h 120.18 V 179.359" style="fill:var(--custom-color-for-logo);fill-opacity:1;fill-rule:nonzero;stroke:none" id="path18"/>
          <path d="m 2449.19,441.582 119.59,27.109 219.15,-289.332 h -142.56 z m -233.27,87.777 h 292.19 c 22.77,0 42.99,5.5 60.67,16.5 17.67,11 31.31,26.59 40.95,46.84 9.62,20.211 14.42,43.492 14.42,69.801 0,26.301 -4.8,49.578 -14.42,69.809 -9.64,20.211 -23.17,35.82 -40.64,46.82 -17.49,11.012 -37.8,16.512 -60.98,16.512 h -292.19 v 114.281 h 287.47 c 49.49,0 92.97,-10.211 130.49,-30.652 37.51,-20.411 66.58,-49.379 87.18,-86.872 20.62,-37.507 30.94,-80.808 30.94,-129.898 0,-49.102 -10.42,-92.398 -31.23,-129.891 -20.83,-37.507 -49.98,-66.48 -87.47,-86.89 -37.51,-20.438 -80.82,-30.637 -129.91,-30.637 h -287.47 z m -52.43,380.563 h 120.18 V 179.359 h -120.18 v 730.563" style="fill:var(--custom-color-for-logo);fill-opacity:1;fill-rule:nonzero;stroke:none" id="path20"/>
          <path d="M 175.285,723.352 379.809,909.328 H 243.199 L 175.285,847.57 V 723.352" style="fill:#f3c40a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path22"/>
          <path d="m 534.648,659.211 c -7.671,-17.602 -19.945,-30.723 -35.089,-40.152 -15.153,-9.43 -32.489,-14.137 -51.996,-14.137 H 295.969 v 184.726 h 151.594 c 19.859,0 37.265,-4.718 52.257,-14.136 14.973,-9.43 30.461,-29.653 36.77,-52.782 4.609,-16.902 5.742,-46.902 -1.942,-63.519 z m 0,-305.891 c -7.671,-17.601 -19.945,-30.718 -35.089,-40.148 -15.153,-9.434 -32.489,-14.141 -51.996,-14.141 H 295.969 v 184.731 h 151.594 c 19.859,0 37.265,-4.723 52.257,-14.153 14.973,-9.418 30.461,-29.648 36.77,-52.769 4.609,-16.91 5.742,-46.91 -1.942,-63.52 z m 85.957,191.282 c 11.954,12.109 22.325,25.839 30.946,41.367 17.836,32.133 26.765,69.242 26.765,111.312 0,42.078 -8.847,79.188 -26.519,111.34 -17.652,32.129 -42.563,56.949 -74.711,74.449 -32.152,17.508 -69.422,26.258 -111.828,26.258 h -38.41 L 175.285,680.578 V 179.359 h 43.598 76.586 0.5 169.289 c 42.07,0 79.183,8.731 111.336,26.25 32.125,17.493 57.105,42.321 74.957,74.473 17.836,32.129 26.765,69.238 26.765,111.309 0,42.07 -8.847,79.179 -26.519,111.328 -8.641,15.73 -19.074,29.652 -31.192,41.883" style="fill:var(--custom-color-for-logo);fill-opacity:1;fill-rule:nonzero;stroke:none" id="path24"/>
          <path d="M 1813.18,2580.64 811.82,1670.09 V 1296.3 l 947.88,861.92 c 37.97,43.43 57.86,105.06 57.86,171.83 v 184.91 c 0,23.41 -1.58,45.18 -4.38,65.68" style="fill:#f3c40a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path26"/>
          <path d="m 2000.52,1964.56 c -35.55,25.98 -75.67,46.04 -118.97,57.89 l -238.39,-216.52 -563.4,-512.34 h 531.49 c 10.94,0 21.42,0 31.91,0.91 v -0.91 h 136.74 c 102.56,0 195.55,41.48 262.55,108.94 67.47,67.46 108.94,160.45 108.94,263.01 0,122.62 -59.25,231.56 -150.87,299.02" style="fill:var(--custom-color-for-logo);fill-opacity:1;fill-rule:nonzero;stroke:none" id="path28"/>
          <path d="m 2733.93,1187.09 c -59.28,0 -107.51,-48.23 -107.51,-107.51 0,-59.28 48.23,-107.51 107.51,-107.51 59.28,0 107.51,48.23 107.51,107.51 0,59.28 -48.23,107.51 -107.51,107.51 z m 0,-231.051 c -68.12,0 -123.54,55.421 -123.54,123.541 0,68.12 55.42,123.54 123.54,123.54 68.12,0 123.54,-55.42 123.54,-123.54 0,-68.12 -55.42,-123.541 -123.54,-123.541" style="fill:var(--custom-color-for-logo);fill-opacity:1;fill-rule:nonzero;stroke:none" id="path30"/>
          <path d="m 2705.12,1136.26 v -52.92 h 23.21 c 4.28,0 8.23,0.65 11.86,1.93 3.63,1.29 6.77,3.14 9.41,5.55 2.65,2.41 4.72,5.36 6.21,8.86 1.49,3.49 2.24,7.41 2.24,11.75 0,7.8 -2.53,13.89 -7.58,18.27 -5.06,4.38 -12.36,6.56 -21.94,6.56 z m 87.53,-130.47 h -20.35 l -24.43,40.91 c -2.23,3.8 -4.41,7.04 -6.51,9.72 -2.1,2.68 -4.26,4.87 -6.46,6.57 -2.21,1.69 -4.58,2.93 -7.13,3.71 -2.54,0.78 -5.41,1.17 -8.6,1.17 h -14.05 v -62.08 h -17.09 v 145.94 h 43.56 c 6.37,0 12.26,-0.8 17.65,-2.39 5.4,-1.59 10.08,-4.02 14.05,-7.28 3.97,-3.25 7.07,-7.31 9.31,-12.16 2.24,-4.85 3.36,-10.53 3.36,-17.04 0,-5.09 -0.76,-9.76 -2.29,-14 -1.53,-4.24 -3.7,-8.02 -6.51,-11.35 -2.81,-3.32 -6.21,-6.15 -10.18,-8.49 -3.97,-2.35 -8.43,-4.16 -13.38,-5.45 v -0.41 c 2.44,-1.08 4.56,-2.32 6.36,-3.71 1.8,-1.39 3.51,-3.04 5.14,-4.94 1.63,-1.9 3.23,-4.05 4.83,-6.46 1.6,-2.41 3.37,-5.21 5.35,-8.39 l 27.37,-43.87" style="fill:var(--custom-color-for-logo);fill-opacity:1;fill-rule:nonzero;stroke:none" id="path32"/>
        </g>
      </g>
    </svg>
    <h1 class="mt-8">404</h1>
    <p i18n>صفحه مورد نظر یافت نشد.</p>
  </div>
  <div class="stack-container">
    <div class="card-container">
      <div class="perspec" style="--spreaddist: 125px; --scaledist: .75; --vertdist: -25px;">
        <div class="card">
          <div class="writing">
            <div class="topbar">
              <div class="red"></div>
              <div class="yellow"></div>
              <div class="green"></div>
            </div>
            <div class="code">
              <ul></ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-container">
      <div class="perspec" style="--spreaddist: 100px; --scaledist: .8; --vertdist: -20px;">
        <div class="card">
          <div class="writing">
            <div class="topbar">
              <div class="red"></div>
              <div class="yellow"></div>
              <div class="green"></div>
            </div>
            <div class="code">
              <ul></ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-container">
      <div class="perspec" style="--spreaddist:75px; --scaledist: .85; --vertdist: -15px;">
        <div class="card">
          <div class="writing">
            <div class="topbar">
              <div class="red"></div>
              <div class="yellow"></div>
              <div class="green"></div>
            </div>
            <div class="code">
              <ul></ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-container">
      <div class="perspec" style="--spreaddist: 50px; --scaledist: .9; --vertdist: -10px;">
        <div class="card">
          <div class="writing">
            <div class="topbar">
              <div class="red"></div>
              <div class="yellow"></div>
              <div class="green"></div>
            </div>
            <div class="code">
              <ul></ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-container">
      <div class="perspec" style="--spreaddist: 25px; --scaledist: .95; --vertdist: -5px;">
        <div class="card">
          <div class="writing">
            <div class="topbar">
              <div class="red"></div>
              <div class="yellow"></div>
              <div class="green"></div>
            </div>
            <div class="code">
              <ul></ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-container">
      <div class="perspec" style="--spreaddist: 0px; --scaledist: 1; --vertdist: 0px;">
        <div class="card">
          <div class="writing">
            <div class="topbar">
              <div class="red"></div>
              <div class="yellow"></div>
              <div class="green"></div>
            </div>
            <div class="code">
              <ul></ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
